// extracted by mini-css-extract-plugin
export default {"table":"multi-link-generator_table__a7aeE"};